import React, { useEffect, useState } from "react";
import './GridOptions.scss';
import { InputCharactersCounter } from "components/SideBarItems/Input";
import { useAppSelector } from "hooks/redux";
import { selectSelectedTab } from "store/workspace/slice";
import { api } from "api/root";
import { SmartDataOptions } from "components/SmartDataOptions/SmartDataOptions";

export const GridOptions: React.FC = () => {
    const [opened, setOpened] = useState<boolean>(true);
    const selectedTab = useAppSelector(selectSelectedTab);
    const { workspaceId } = useAppSelector(state => state.workspaceSlice);
    const [title, setTitle] = useState<string>(selectedTab?.title || '');

    // Sync local title state with selectedTab title when it changes
    useEffect(() => {
        if (selectedTab?.title !== undefined) {
            setTitle(selectedTab.title);
        }
    }, [selectedTab?.title]);

    const handleChangeValue = (obj: { element?: string, value?: unknown }): void => {
        if (obj.element === 'title' && typeof obj.value === 'string') {
            setTitle(obj.value);
        }
    }

    const handleSaveValues = async (element?: string) => {
        if (element === 'title' && selectedTab?.id && title) {
            // Save to backend - InputCharactersCounter already handles updating Redux state
            try {
                await api.put(`/Workspace/${workspaceId}/GridView/${selectedTab.id}`, { 
                    title: title 
                });
            } catch (error) {
                console.error('Error saving grid title:', error);
            }
        }
    };

    return (
        <div className="gridOptions">
            <div className="contentVisibilityHandler">
                <h3>
                    <span 
                        onClick={() => setOpened(!opened)} 
                        className={opened ? "k-icon k-i-caret-alt-down" : "k-icon k-i-caret-alt-right"}
                    ></span>
                    Grid Options
                </h3>
            </div>
            <div className={opened ? "content" : "content closed"}>
                <InputCharactersCounter
                    label="Grid Title"
                    element="title"
                    max={250}
                    value={title}
                    group={null}
                    setFunction={handleChangeValue}
                    saveFunction={handleSaveValues}
                />
                <SmartDataOptions />
            </div>
        </div>
    )
}

